import './style.scss';

import { ISADMINLOGGED } from '../constants/global';

const ChildWrapper = ({ children }: { children?: any }) => {
	const notlogged = ISADMINLOGGED() ? '' : 'notlogged';
	return (
		<div className={`child-wrapper-container ${notlogged}`}>
			<div className='child-wrapper'>{children}</div>
		</div>
	);
};

export default ChildWrapper;
